<div class="wrap-1200">
  <app-ir-sent-table
    [projectData]="projects"
    [idUser]="idUser"
    [loader]="loader">
  </app-ir-sent-table>
</div>